var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMysterySet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,36c-.64-3.4-.57-6.01,7.5-8.7,3.11-1.06,4.74-1.56,4.74-3.4,0-1.56-1.56-2.05-3.18-2.05-3.18,0-4.95,1.13-6.93,2.48-2.19,1.49-2.97,3.18-6.23,3.18-4.74,0-6.16-5.24-4.32-10.54,2.55-7.15,7.64-11.32,20.52-11.32,14.08,0,20.1,5.45,20.1,16.49-.07,8.84-2.76,11.11-8.14,13.44-3.26,1.49-4.53,1.91-5.87,3.47-2.26,2.97-3.11,2.12-9.41,2.12-5.52,0-7.71,.85-8.77-5.17Zm-2.26,14.72c0-5.31,3.61-7.78,11.75-7.78s12.03,2.48,12.03,7.78-3.68,7.64-12.03,7.64-11.75-2.55-11.75-7.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMysterySet);
export default __webpack_public_path__ + "static/media/icon_mystery-set.86dcccec.svg";
export { ForwardRef as ReactComponent };